import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Lightbox from 'react-images';
import Img from 'gatsby-image';
import styled from 'styled-components';
import { GalleryItem } from './GalleryItem';

const GalleryLink = styled.a`
  transition: transform 1s;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 33%;
  margin: 1px;
`;
const Caption = styled.p`
  margin: 0px;
  overflow: hidden;
  position: absolute;
  z-index: 2;
  padding: 10px;
  bottom: 0;
  right: 0;
  font-size: 0.7rem;
  letter-spacing: 0.04rem;
  background: ${props => props.theme.secondaryColor};
  color: ${props => props.theme.white};
`;
/**
 * A compnent for showing a gallery and on clicking an image will display a large version in a modal box.
 */
export default class Gallery extends Component {
  constructor() {
    super();

    this.state = {
      lightboxIsOpen: false,
      currentImage: 0
    };

    this.closeLightbox = this.closeLightbox.bind(this);
    this.gotoNext = this.gotoNext.bind(this);
    this.gotoPrevious = this.gotoPrevious.bind(this);
    this.gotoImage = this.gotoImage.bind(this);
    this.handleClickImage = this.handleClickImage.bind(this);
    this.openLightbox = this.openLightbox.bind(this);
  }
  openLightbox(index, event) {
    event.preventDefault();
    this.setState({
      currentImage: index,
      lightboxIsOpen: true
    });
  }
  closeLightbox() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false
    });
  }
  gotoPrevious() {
    this.setState({
      currentImage: this.state.currentImage - 1
    });
  }
  gotoNext() {
    this.setState({
      currentImage: this.state.currentImage + 1
    });
  }
  gotoImage(index) {
    this.setState({
      currentImage: index
    });
  }
  handleClickImage() {
    if (this.state.currentImage === this.props.images.length - 1) return;

    this.gotoNext();
  }

  renderGallery() {
    const { images } = this.props;

    if (!images) return;

    const gallery = images.map((obj, i) => {
      return (
        <GalleryLink
          href={obj.src}
          key={i}
          onClick={e => this.openLightbox(i, e)}
        >
          <GalleryItem inline={this.props.inline}>
            <Img
              fluid={obj.fluid}
              alt={obj.alt}
              loading="lazy"
              style={{
                position: 'absolute',
                left: 0,
                top: 0,
                width: '100%',
                height: '100%',
                overflow: 'hidden',
                zIndex: 1
              }}
            />
            <Caption>{obj.caption}</Caption>
          </GalleryItem>
        </GalleryLink>
      );
    });

    return <>{gallery}</>;
  }

  render() {
    return (
      <>
        {this.renderGallery()}

        <Lightbox
          currentImage={this.state.currentImage}
          images={this.props.images}
          isOpen={this.state.lightboxIsOpen}
          onClickImage={this.handleClickImage}
          onClickNext={this.gotoNext}
          onClickPrev={this.gotoPrevious}
          onClickThumbnail={this.gotoImage}
          onClose={this.closeLightbox}
          caption={this.props.images}
          alt={this.props.images}
        />
      </>
    );
  }
}

Gallery.displayName = 'Gallery';
Gallery.propTypes = {
  images: PropTypes.array.isRequired,
  inline: PropTypes.bool
};

export { Gallery };
